import React, { useState } from 'react';
import { useDemo } from '../providers/DemoProvider';
import { PACKS } from '../../../data/packs';
import { Muse } from '../../../types';
import RarityGem from '../../../shared/ui/RarityGem';
import '../../muses/styles/Inventory.css';

const DemoMyMuses: React.FC = () => {
  const { inventory, equippedMuseId, setEquippedMuse, showLockedModal } = useDemo();
  const [showPacks, setShowPacks] = useState(true);

  const unlockedMap: Record<string, Muse> = {};
  inventory.forEach(m => {
    if (m.name) {
      unlockedMap[m.name] = m;
    }
  });

  const rarityOrder: Record<string, number> = { Legendary: 0, Epic: 1, Rare: 2, Uncommon: 3, Common: 4 };

  const allMuses = Object.values(PACKS).flatMap(p => p.muses).sort((a, b) => {
    const rarityA = unlockedMap[a.name] ? rarityOrder[a.rarity] : 99;
    const rarityB = unlockedMap[b.name] ? rarityOrder[b.rarity] : 99;
    if (rarityA !== rarityB) return rarityA - rarityB;
    return a.name.localeCompare(b.name);
  });

  const handleSelectMuse = (muse: Muse) => {
    if (unlockedMap[muse.name]) {
      setEquippedMuse(muse.name);
    } else {
      showLockedModal();
    }
  };

  return (
    <div className="inventory-container" style={{ position: 'relative' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h1 style={{ fontFamily: '"Fredoka One", "Arial Rounded MT Bold", Arial, sans-serif', fontWeight: 900, fontSize: '2.5rem', color: '#2196f3', marginRight: '2.5rem', marginBottom: 0 }}>My Muses</h1>
        <div className="toggle-box" style={{ background: '#e3f4fd', borderRadius: '1.5rem', padding: '0.3rem', display: 'inline-flex', boxShadow: '0 2px 8px rgba(79,195,247,0.10)' }}>
          <button className={showPacks ? 'toggle-btn active' : 'toggle-btn'} style={{ borderRadius: '1.2rem 0 0 1.2rem' }} onClick={() => setShowPacks(true)}>Show Packs</button>
          <button className={!showPacks ? 'toggle-btn active' : 'toggle-btn'} style={{ borderRadius: '0 1.2rem 1.2rem 0' }} onClick={() => setShowPacks(false)}>Show All</button>
        </div>
      </div>

      <div style={{ background: 'linear-gradient(135deg, #e3f4fd 0%, #ede7f6 100%)', borderRadius: '2rem', boxShadow: '0 4px 24px rgba(79,195,247,0.10)', padding: '2.5rem 2rem', margin: '0 auto', maxWidth: 1200, fontFamily: 'Fredoka One, Arial Rounded MT Bold, Arial, sans-serif', fontWeight: 700, }}>
        {showPacks ? (
          Object.entries(PACKS).map(([packId, pack]) => (
            <div key={packId} className="inventory-section" style={{ marginBottom: '2.5rem' }}>
              <h2 className="inventory-title" style={{ color: '#2196f3', fontWeight: 900, fontSize: '2rem', marginBottom: '1rem', textAlign: 'center' }}>{pack.name}</h2>
              <div className="muses-row center-muses">
                {pack.muses.map((muse, i) => {
                  const unlocked = unlockedMap[muse.name];
                  const isSelected = equippedMuseId === muse.name;
                  return (
                    <div
                      key={i}
                      className={`muse-circle-card${unlocked ? ' unlocked' : ' locked'}${isSelected ? ' selected' : ''}`}
                      onClick={() => handleSelectMuse(muse)}
                      style={{ cursor: 'pointer' }}
                    >
                      <RarityGem rarity={muse.rarity} className="muse-rarity-gem" style={{ position: 'absolute', top: 8, left: 8, zIndex: 2 }} />
                      <div className="muse-emoji-main-circle">
                        {unlocked ? (
                          <img src={muse.img} alt={muse.name} style={{ width: 72, height: 72, filter: 'drop-shadow(0 6px 12px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                        ) : (
                          <span role="img" aria-label="locked">🔒</span>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        ) : (
          <div className="muses-all-grid center-muses">
            {allMuses.map((muse, i) => {
              const unlocked = unlockedMap[muse.name];
              const isSelected = equippedMuseId === muse.name;
              return (
                <div
                  key={i}
                  className={`muse-circle-card${unlocked ? ' unlocked' : ' locked'}${isSelected ? ' selected' : ''}`}
                  onClick={() => handleSelectMuse(muse)}
                   style={{ cursor: 'pointer' }}
                >
                  <RarityGem rarity={muse.rarity} className="muse-rarity-gem" style={{ position: 'absolute', top: 8, left: 8, zIndex: 2 }} />
                  <div className="muse-emoji-main-circle">
                    {unlocked ? (
                      <img src={muse.img} alt={muse.name} style={{ width: 72, height: 72, filter: 'drop-shadow(0 6px 12px rgba(0, 0, 0, 0.3))', borderRadius: '6px' }} />
                    ) : (
                      <span role="img" aria-label="locked">🔒</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default DemoMyMuses;
